import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel']

  toggle() {
    document.getElementById('mobilemenu').classList.toggle('sm:hidden');
  }

  toggleDesktop() {
    const nav = this.element;
    const isCollapsed = nav.classList.toggle('sidebar-collapsed');

    // Toggle width
    if (isCollapsed) {
      nav.classList.remove('w-[247px]');
      nav.classList.add('w-[131px]');
    } else {
      nav.classList.remove('w-[131px]');
      nav.classList.add('w-[247px]');
    }

    // Toggle visibility of text labels and arrows
    nav.querySelectorAll('[data-sidebar-label]').forEach(el => el.classList.toggle('hidden'));
    nav.querySelectorAll('[data-sidebar-arrow]').forEach(el => el.classList.toggle('hidden'));

    // Toggle logo visibility
    nav.querySelectorAll('[data-sidebar-logo]').forEach(el => el.classList.toggle('hidden'));

    // Toggle padding for centered icons in collapsed mode
    const menuContainer = nav.querySelector('[data-sidebar-menu]');
    if (menuContainer) {
      menuContainer.classList.toggle('pl-7');
      menuContainer.classList.toggle('pr-6');
      menuContainer.classList.toggle('px-0');
      menuContainer.classList.toggle('items-center');
    }

    // Center the header row (toggle button area)
    const headerRow = nav.querySelector('[data-sidebar-header]');
    if (headerRow) {
      headerRow.classList.toggle('pl-7');
      headerRow.classList.toggle('px-0');
      headerRow.classList.toggle('justify-center');
    }

    // Rotate toggle button 180°
    const toggleBtn = nav.querySelector('[data-sidebar-toggle]');
    if (toggleBtn) {
      toggleBtn.classList.toggle('rotate-180');
    }

    // Toggle link alignment
    nav.querySelectorAll('[data-sidebar-link]').forEach(link => {
      link.classList.toggle('justify-center');
    });

    // Toggle background
    //nav.classList.toggle('bg-white');

    // Remove logout icon margin in collapsed mode
    const logoutIcon = nav.querySelector('[data-sidebar-logout] .icon');
    const logoutSpan = nav.querySelector('[data-sidebar-logout]');
    if (headerRow) {
      headerRow.classList.toggle('pr-4');
    }

    if(logoutSpan) {
      logoutSpan.classList.toggle('mx-auto');
    }
  }
}